import React from 'react';
import { Link } from "react-router-dom";

export const SightcartTribe = () => {
	return (
		<div className="xl:mt-20 mt-8 mb-4">
			<div className="border_style">
				<h2 className="flex xl:mb-8 mb-4 x;Ltext-3xl text-xl">Join The Lenskart Tribe</h2>
				<div className="flex gap-4 mx-auto w-auto">
					<Link to="#" className="w-1/6"><img src="images/girl-1.jpg" alt="Image1" /></Link>
					<Link to="#" className="w-1/6"><img src="images/girl-2.jpg" alt="Image1" /></Link>
					<Link to="#" className="w-1/6"><img src="images/girl-3.jpg" alt="Image1" /></Link>
					<Link to="#" className="w-1/6"><img src="images/girl-4.jpg" alt="Image1" /></Link>
					<Link to="#" className="w-1/6"><img src="images/girl-5.jpg" alt="Image1" /></Link>
					<Link to="#" className="w-1/6"><img src="images/girl-6.jpg" alt="Image1" /></Link>
				</div>
			</div>

		</div>
	)
}
